import PasswordRecovery from './PasswordRecovery';

export default PasswordRecovery;
